module.exports = __webpack_public_path__ + "img/云广播系统1.059fe3ce.png";